import Mandotory from "./Mandotory";

export const Label = ({ label, mandatory = false }) => (
  <label>
    {label} {mandatory && <Mandotory classes="text-red"></Mandotory>}
  </label>
);
